import { createSlice, createAction } from '@reduxjs/toolkit';

const NAME = 'toaster';

const SUCCESS = 'success';
const ERORR = 'error';

const addSuccess = createAction('toaster/addSuccess');
const addError = createAction('toaster/addError');
const archiveToast = createAction('toaster/archive');

function _u(s, t) {
	return {
		type: t,
		message: s,
		date: new Date(),
	};
}

const toasterSlice = createSlice({
	name: NAME,
	initialState: { messages: [], archive: [] },
	reducers: {
		addSuccess: (state, action) => {
			state.messages.push(_u(action.payload, SUCCESS));
		},
		addError: (state, action) => {
			state.messages.push(_u(action.payload, ERROR));			
		},
		archive: (state, action) => {
			state.messages = state.messages.filter( (m, i) => action.payload.date != m.date );
			state.archive.push(action.payload);
		},

	},
	extraReducers: (builder) => {
	}
});


// export { hudSlice, setCurrentUser };

export { addSuccess, addError, archiveToast };
export default toasterSlice.reducer; 
